import React from "react";
import { connect } from 'react-redux'
import FullSearchActions from "../../../Redux/FullSearch"
import "./_index.scss";

import SearchHeader from "../Header"
import SearchResult from "../Result"
import { withRouter } from 'react-router';

class SearchPage extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const _searchKey = (PubHub.util.QueryString["q"] || this.props.searchKeyParam);
        const searchKey = this._parseSearchKey(_searchKey);
        const activedType = location.hash && location.hash.slice("#".length);
        this._search(searchKey, activedType);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.searchKeyParam != this.props.searchKeyParam) {
            const searchKey = this._parseSearchKey(nextProps.searchKeyParam);
            this._search(searchKey);
        }
    }

    _search(keyword, activedType) {
        const searchKey = keyword.trim();
        if (searchKey) {
            this.props.fullSearch({ searchKey, activedType: activedType || this.props.activedType, pageNum: 0 });
        } else {
          this.props.clearFullSearch({ activedType: activedType || this.props.activedType });
        }
    }

    _parseSearchKey(originSearchKey) {
        return originSearchKey.replace('/', ' > ');
    }

    _onChangeSearchKeyword = (e) => {
        this.props.changeKeyword({ keyword: e.target.value });
    }

    _onSearch = (keyword) => {
      const searchKey = keyword.trim();
      this.props.router.push('/search/' + searchKey + window.location.hash);
    }

    _onChangeActivedType = (activedType) => {
        this.props.changeActivedType({ searchKey: this.props.searchKey, activedType, pageNum: 0 });
    }

    _onChangeNum = (pageNum) => {
        this.props.changePageNum({ searchKey: this.props.searchKey, activedType: this.props.activedType, pageNum });
    }

    render() {
        const { searchKey } = this.props;

        return (
            <div className='dn-search-page'>
                <SearchHeader
                    searchKey={searchKey}
                    keyword={this.props.keyword}
                    activedType={this.props.activedType}
                    result={this.props.result}
                    onChangeSearchKey={this._onChangeSearchKeyword}
                    onSearch={this._onSearch}
                    pageNum={this.props.pageNum}
                    onChangeActivedType={this._onChangeActivedType} />

                <SearchResult
                    searchKey={searchKey}
                    pageNum={this.props.pageNum}
                    pageSize={this.props.pageSize}
                    busy={this.props.searching}
                    activedType={this.props.activedType}
                    result={this.props.result}
                    onChangeNum={this._onChangeNum} />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        pageNum: state.full_search.pageNum,
        pageSize: state.full_search.pageSize,
        searching: state.full_search.searching,
        activedType: state.full_search.activedType,
        keyword: state.full_search.keyword,
        searchKey: state.full_search.searchKey,
        result: state.full_search.result,
    }
};

const mapDispatchToProps = (dispatch) => ({
    changeKeyword: (args) => dispatch(FullSearchActions.changeKeyword(args)),
    changeActivedType: (args) => dispatch(FullSearchActions.changeActivedType(args)),
    changePageNum: (args) => dispatch(FullSearchActions.changeSearchPageNum(args)),
    fullSearch: (args) => dispatch(FullSearchActions.fullSearch(args)),
    clearFullSearch: (args) => dispatch(FullSearchActions.clearFullSearch(args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SearchPage))